export const translations = {
  en: {
    nav: {
      services: "Services",
      process: "Process",
      work: "Work",
      login: "Log in",
      cta: "Start a project ↗",
      contact: "Contact",
    },
    hero: {
      label: "Full-stack software development",
      line1: "We build",
      line2: "software",
      line3: "that scales",
      subtitle:
        "Custom development, modern stack, and clear processes. From idea to launch and beyond — we're the technical partner your product needs.",
      cta1: "Start your build",
      cta2: "Explore work",
    },
    services: {
      label: "Core competencies",
      heading: "What we do",
      description:
        "End-to-end development and technical guidance for every stage of your product.",
      items: [
        {
          title: "Web applications",
          description:
            "Scalable, maintainable web apps engineered for performance and long-term growth.",
          link: "Explore services",
        },
        {
          title: "APIs & backends",
          description:
            "Robust server-side systems, APIs, and data pipelines built to handle real load.",
          link: "Explore services",
        },
        {
          title: "Consulting & audits",
          description:
            "Architecture reviews, technical roadmaps, and process guidance for your team.",
          link: "Explore services",
        },
      ],
    },
    howWeWork: {
      label: "Protocol",
      heading: "How we work",
      description:
        "A transparent, repeatable process from kickoff to long-term support.",
      steps: [
        {
          step: "01",
          title: "Discovery",
          description:
            "We align on goals, scope, and constraints — before writing a single line of code.",
        },
        {
          step: "02",
          title: "Design & build",
          description:
            "Iterative development with regular demos, clear milestones, and open communication.",
        },
        {
          step: "03",
          title: "Launch & support",
          description:
            "Deploy with confidence, monitor closely, and keep evolving with you long-term.",
        },
      ],
    },
    whyUs: {
      label: "Why Spotynet",
      heading: "Built different",
      description: "We focus on delivery you can trust and systems you can grow.",
      points: [
        {
          icon: "◈",
          title: "Modern stack",
          description:
            "We choose proven, maintainable technologies that your team can own for years.",
        },
        {
          icon: "◈",
          title: "Clear process",
          description:
            "Weekly updates, documented decisions, and zero surprise scope creep.",
        },
        {
          icon: "◈",
          title: "Long-term focus",
          description:
            "We write code and architect systems with the next 3 years in mind, not just launch day.",
        },
      ],
    },
    work: {
      label: "Selected works",
      heading: "Project highlights",
      allProjects: "All projects →",
      viewProject: "Visit site",
      projects: {
        intacsep: {
          category: "Web platform",
          title: "Intacsep",
          result: "Fleet monitoring & anomaly dashboards for transport logistics",
        },
        homly: {
          category: "Web app",
          title: "Homly",
          result: "Condominium management — billing, residents & operations",
        },
        nabbi: {
          category: "Mobile + web",
          title: "Nabbi",
          result: "Beauty, wellness & pet services marketplace",
        },
      },
    },
    contact: {
      label: "Get in touch",
      heading: "Start a project",
      description:
        "Tell us what you're building. We'll get back to you within one business day.",
      nameLbl: "Name",
      namePlaceholder: "Your name",
      emailLbl: "Email",
      emailPlaceholder: "you@company.com",
      messageLbl: "Message",
      messagePlaceholder: "Tell us about your project, timeline, and goals…",
      submit: "Send message ↗",
    },
    footer: {
      copyright: "All rights reserved.",
      services: "Services",
      process: "Process",
      work: "Work",
      contact: "Contact",
    },
  },

  es: {
    nav: {
      services: "Servicios",
      process: "Proceso",
      work: "Proyectos",
      login: "Iniciar sesión",
      cta: "Iniciar proyecto ↗",
      contact: "Contacto",
    },
    hero: {
      label: "Desarrollo de software full-stack",
      line1: "Construimos",
      line2: "software",
      line3: "que escala",
      subtitle:
        "Desarrollo a medida, stack moderno y procesos claros. De la idea al lanzamiento y más allá — somos el socio técnico que tu producto necesita.",
      cta1: "Comienza tu proyecto",
      cta2: "Ver proyectos",
    },
    services: {
      label: "Competencias clave",
      heading: "Qué hacemos",
      description:
        "Desarrollo integral y guía técnica en cada etapa de tu producto.",
      items: [
        {
          title: "Aplicaciones web",
          description:
            "Apps web escalables y mantenibles, diseñadas para rendimiento y crecimiento a largo plazo.",
          link: "Ver servicios",
        },
        {
          title: "APIs y backends",
          description:
            "Sistemas del lado del servidor, APIs y pipelines de datos robustos para manejar carga real.",
          link: "Ver servicios",
        },
        {
          title: "Consultoría y auditorías",
          description:
            "Revisiones de arquitectura, hojas de ruta técnicas y orientación de procesos para tu equipo.",
          link: "Ver servicios",
        },
      ],
    },
    howWeWork: {
      label: "Protocolo",
      heading: "Cómo trabajamos",
      description:
        "Un proceso transparente y repetible desde el inicio hasta el soporte a largo plazo.",
      steps: [
        {
          step: "01",
          title: "Descubrimiento",
          description:
            "Alineamos objetivos, alcance y restricciones — antes de escribir una sola línea de código.",
        },
        {
          step: "02",
          title: "Diseño y desarrollo",
          description:
            "Desarrollo iterativo con demos regulares, hitos claros y comunicación abierta.",
        },
        {
          step: "03",
          title: "Lanzamiento y soporte",
          description:
            "Desplegamos con confianza, monitoreamos de cerca y seguimos evolucionando contigo.",
        },
      ],
    },
    whyUs: {
      label: "Por qué Spotynet",
      heading: "Construidos diferente",
      description:
        "Nos enfocamos en entregas confiables y sistemas que pueden crecer.",
      points: [
        {
          icon: "◈",
          title: "Stack moderno",
          description:
            "Elegimos tecnologías probadas y mantenibles que tu equipo puede dominar por años.",
        },
        {
          icon: "◈",
          title: "Proceso claro",
          description:
            "Actualizaciones semanales, decisiones documentadas y cero cambios de alcance sorpresivos.",
        },
        {
          icon: "◈",
          title: "Visión a largo plazo",
          description:
            "Escribimos código y arquitecturas pensando en los próximos 3 años, no solo en el lanzamiento.",
        },
      ],
    },
    work: {
      label: "Proyectos seleccionados",
      heading: "Destacados",
      allProjects: "Todos los proyectos →",
      viewProject: "Visitar sitio",
      projects: {
        intacsep: {
          category: "Plataforma web",
          title: "Intacsep",
          result: "Monitoreo de flota y dashboards de anomalías para logística",
        },
        homly: {
          category: "App web",
          title: "Homly",
          result: "Administración de condominios — cobranza, residentes y operación",
        },
        nabbi: {
          category: "Móvil + web",
          title: "Nabbi",
          result: "Marketplace de belleza, bienestar y servicios para mascotas",
        },
      },
    },
    contact: {
      label: "Contáctanos",
      heading: "Inicia un proyecto",
      description:
        "Cuéntanos qué estás construyendo. Te responderemos en un día hábil.",
      nameLbl: "Nombre",
      namePlaceholder: "Tu nombre",
      emailLbl: "Correo",
      emailPlaceholder: "tú@empresa.com",
      messageLbl: "Mensaje",
      messagePlaceholder: "Cuéntanos sobre tu proyecto, plazos y objetivos…",
      submit: "Enviar mensaje ↗",
    },
    footer: {
      copyright: "Todos los derechos reservados.",
      services: "Servicios",
      process: "Proceso",
      work: "Proyectos",
      contact: "Contacto",
    },
  },
} as const;

export type Lang = keyof typeof translations;
export type Translations = (typeof translations)[Lang];
